import
  React
from 'react';

export default ({
  size = '24'
}) => (
  <svg
    fill="none"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      stroke="#333333"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.7575 14.825V11.675H16.3325"
    />
    <path
      stroke="#333333"
      strokeWidth="1.6"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11.1487 11.675V14.825C11.1487 14.825 13.0525 15.0875 13.0525 13.25C13.0525 11.4125 11.1487 11.675 11.1487 11.675Z"
    />
    <path
      stroke="#333333"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.60501 14.825V11.675H8.52376C8.52376 11.675 9.44251 11.6088 9.44251 12.5938C9.44251 13.5788 8.52376 13.5125 8.52376 13.5125H7.60501"
    />
    <path
      stroke="#333333"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.7575 13.25H16.07"
    />
    <path
      stroke="#333333"
      strokeWidth="1.6"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      d="M18.5 6.5L14.5 2.5H7C6.17157 2.5 5.5 3.17157 5.5 4V20C5.5 20.8284 6.17157 21.5 7 21.5H17C17.8284 21.5 18.5 20.8284 18.5 20V6.5Z"
    />
    <path
      stroke="#333333"
      strokeWidth="1.6"
      strokeLinecap="round"
      d="M14.5 2.5V6.5H18.5"
      strokeLinejoin="round"
    />
  </svg>
);